'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWaves = function TiWaves(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25 31.7c-2.2 0-4.5-0.9-6.2-2.6-2.1-2.1-5.5-2.1-7.6 0-0.7 0.7-1.7 0.7-2.4 0s-0.6-1.7 0-2.3c3.4-3.4 9-3.4 12.4 0 2.1 2.1 5.5 2.1 7.6 0 0.7-0.7 1.7-0.7 2.4 0s0.6 1.7 0 2.3c-1.7 1.7-4 2.6-6.2 2.6z m0-6.7c-2.2 0-4.5-0.9-6.2-2.6-2.1-2.1-5.5-2.1-7.6 0-0.7 0.7-1.7 0.7-2.4 0s-0.6-1.7 0-2.3c3.4-3.4 9-3.4 12.4 0 2.1 2.1 5.5 2.1 7.6 0 0.7-0.7 1.7-0.7 2.4 0s0.6 1.7 0 2.3c-1.7 1.7-4 2.6-6.2 2.6z m0-6.7c-2.2 0-4.5-0.8-6.2-2.5-2.1-2.1-5.5-2.1-7.6 0-0.7 0.6-1.7 0.6-2.4 0s-0.6-1.7 0-2.4c3.4-3.4 9-3.4 12.4 0 2.1 2.1 5.5 2.1 7.6 0 0.7-0.6 1.7-0.6 2.4 0s0.6 1.7 0 2.4c-1.7 1.7-4 2.5-6.2 2.5z' })
        )
    );
};

exports.default = TiWaves;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/waves.js
// module id = 3278
// module chunks = 0